import { MutationTuple, useMutation } from '@apollo/client';
import { ASK_SUPPORT_ASSISTANT } from 'graphql/ai/mutations/askSupportAssistant.gql';
import { SupportContextClientInput } from 'utils/supportContext';

export type SupportCitation = {
  url: string;
  urlPath: string;
  title?: string | null;
  heading?: string | null;
};

export type AskSupportAssistantResult = {
  askSupportAssistant: {
    success: boolean;
    answer?: string | null;
    error?: string | null;
    conversationId?: string | null;
    citations?: SupportCitation[] | null;
  };
};

export type AskSupportAssistantVariables = {
  input: {
    message: string;
    context: SupportContextClientInput;
    conversationId?: string;
  };
};

export const useAskSupportAssistantMutation = (): MutationTuple<
  AskSupportAssistantResult,
  AskSupportAssistantVariables
> => {
  return useMutation(ASK_SUPPORT_ASSISTANT);
};
